
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import FactoryHeroSection from './components/FactoryHeroSection';
import FactoryAdvantagesSection from './components/FactoryAdvantagesSection';
import FactoryCooperationModelsSection from './components/FactoryCooperationModelsSection';
import FactoryRequirementsSection from './components/FactoryRequirementsSection';
import FactorySuccessSection from './components/FactorySuccessSection';
import FactoryApplicationSection from './components/FactoryApplicationSection';
import { updateSEO, addJSONLD } from '../../utils/seo';

export default function FactoryCooperation() {
  useEffect(() => {
    // Update SEO
    updateSEO({
      title: '工厂合作 - 南滇古茶茶叶生产厂家直供平台',
      description: '南滇古茶工厂合作平台，与云南优质茶叶生产厂家直接合作，提供代工生产、品牌孵化、渠道支持等全方位服务。',
      keywords: '茶叶工厂合作,代工生产,茶叶厂家,普洱茶代工,品牌孵化,工厂直供',
      type: 'website',
      url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/factory-cooperation`
    });

    // Add JSON-LD structured data
    addJSONLD({
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "工厂合作服务",
      "description": "为茶叶生产厂家提供品牌孵化和渠道支持",
      "provider": {
        "@type": "Organization",
        "name": "南滇古茶"
      },
      "serviceType": "Manufacturing Partnership",
      "areaServed": "CN",
      "offers": {
        "@type": "Offer",
        "name": "工厂合作计划",
        "description": "提供代工生产、品牌孵化、渠道支持等服务"
      },
      "breadcrumb": {
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "首页",
            "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "工厂合作", 
            "item": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/factory-cooperation`
          }
        ]
      }
    });
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <FactoryHeroSection />
        <FactoryAdvantagesSection />
        <FactoryCooperationModelsSection />
        <FactoryRequirementsSection />
        <FactorySuccessSection />
        <FactoryApplicationSection />
      </main>
      <Footer />
    </div>
  );
}
